import { translate } from 'support/translate';
import AbstractToast from './AbstractToast';
import { AppData, Colors } from '@lightningjs/sdk';

const PADDING_RIGHT = 80;
const DEFAULT_PADDING = 20;
const DEFAULT_MARGIN = 16;
const LINE_HEIGHT = 34;

export default class OfflineErrorToast extends AbstractToast {
  override _setup() {
    this.image = AppData!.offlineErrorService.loadImage();

    this.patch({
      color: Colors('offlineErrorBackground').get(),
      flex: {
        paddingRight: PADDING_RIGHT,
        paddingTop: DEFAULT_PADDING,
        paddingBottom: DEFAULT_PADDING,
      },
      Image: this.image,
      Label: {
        y: 2,
        text: {
          text: translate('error.resolvable.network.offline'),
          textColor: Colors('activeText').get(),
          lineHeight: LINE_HEIGHT,
        },
        flexItem: {
          marginLeft: DEFAULT_MARGIN,
          alignSelf: 'flex-start',
        },
      },
    });
  }
}
